import { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import {
  useAnalysisTypes,
  useEfficiencies,
  useEfficiencyParts,
  useEquipment,
  useEquipmentMide,
  useGeometry,
} from "@services/servicesGenericsTables";
import { Loading } from "@app/components";
import { useCalibrationTritium } from "../../utils/useCalibration";

export default function CalibrationListLayout() {
  const fetched = useRef(false);
  const [loading, setLoading] = useState(true);

  const { fetchAll: fetchAllAnalysis } = useAnalysisTypes();
  const { fetchAll: fetchGeometry } = useGeometry();
  const { fetchAll: fetchEfficiency } = useEfficiencyParts();
  const { fetchAll: fetchEfficiencies } = useEfficiencies();
  const { fetchAll: fetchCalibrationTritium } = useCalibrationTritium();
  const { fetchAll: fetchEquipmentMide } = useEquipmentMide();
  const { fetchAll: fetchEquipment } = useEquipment();
  const { clear } = useEquipmentMide();

  useEffect(() => {
    if (!fetched.current) {
      fetched.current = true;
      const fetchData = async () => {
        await Promise.all([
          fetchAllAnalysis(),
          fetchGeometry(),
          fetchEfficiency(),
          fetchEfficiencies(),
          fetchCalibrationTritium(),
          fetchEquipment(),
          fetchEquipmentMide(),
        ]);
        setLoading(false);
      };
      fetchData();
      clear();
    }
  }, []);

  return loading ? <Loading /> : <Outlet />;
}
